import postRequest from '../../../../../postRequest';

/**
 * Calls upcs endpoint to get products barcode information.
 *
 * @param {number} productId - 15974689
 * @param {string} siteCode - JD
 * @returns {Promise} { data: { Data: [{}], Pagination: {} }, status: 200 }
 */
async function postUpcs(productId, siteCode) {
  const endpoint = '/integration-pim/v1/products/drop-shipment/upcs';

  const body = {
    productId,
    siteCode,
  };
  return new Promise((resolve, reject) => {
    postRequest(endpoint, body, 'UPCs')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

export default postUpcs;
